/**
 * Check if a URL is external (contains protocol)
 */
export function isExternalLink(href) {
  return href?.includes('://');
}

/**
 * Get rel and target props for external links
 * Consistently applies noopener noreferrer for security
 */
export function getExternalLinkProps(href, rel, target) {
  const isExternal = isExternalLink(href);
  return {
    rel: rel || (isExternal ? 'noopener noreferrer' : undefined),
    target: target || (isExternal ? '_blank' : undefined),
  };
}
